import { GET_MOVIES, SET_LOADING, SET_ERROR, UPDATE_MOVIES, SET_LOADING_UPDATE } from '../actionTypes'
import Swal from 'sweetalert2'
let url = `https://server-movie-synopsis.herokuapp.com`
// const url = `http://localhost:3000`


export function getMovies() { 
  
  return (dispatch) => {
    fetch(`${url}/movies`)
    .then(res => res.json())
    .then(movies => {
      dispatch({
        type: GET_MOVIES,
        payload: movies
      })
    })
    .catch(err => {
      dispatch({
        type: SET_ERROR,
        payload: err
      })
    })
    .finally(() => {
      dispatch({
        type: SET_LOADING,
        payload: false
      })
    })
  }
}

export function deleteMovies(id) {
  return (dispatch) => {
    fetch(`${url}/movies/${id}`, {
      method: "DELETE",
      headers: {
        token: localStorage.getItem('token')
      }
    })
    .then((res) => res.json())
    .then(() => {
      Swal.fire(
        'Deleted!',
        'Your file has been deleted.',
        'success'
      )
    })
    .catch((err) => {
      console.log(err)
      dispatch({
        type: SET_ERROR,
        payload: err
      })
    });
  }
}

export function addMovies(data) {
  return (dispatch) => {
    console.log(data)
    fetch(`${url}/movies`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        token: localStorage.getItem('token')
      },
      body: JSON.stringify({
        title: data.title,
        synopsis: data.synopsis,
        trailerUrl: data.trailerUrl,
        imgUrl: data.imgUrl,
        rating: data.rating,
        genreId: +data.genreId,
        price: +data.price,
        quantity: +data.quantity
      })
    })
    .then((res) => res.json())
    .then(movie => {
      Swal.fire('Created!', `${movie.title} was Created`, 'success')
    })
    .catch(err => {
      console.log(err)
      dispatch({
        type: SET_ERROR,
        payload: err
      })
    })
  }
}

export function getMovieById(id) {  
  return (dispatch) => {

    dispatch({
      type: UPDATE_MOVIES,
      payload: {}
    })

    dispatch({
      type: SET_LOADING_UPDATE,
      payload: true
    })

    fetch(`${url}/movies/${id}`)
    .then((res) => res.json())
    .then((movie) => {
      dispatch({
        type: UPDATE_MOVIES,
        payload: movie
      })
    }).catch((err) => {
      dispatch({
        type: SET_ERROR,
        payload: err
      })
    })
    .finally(_ => {
      dispatch({
        type: SET_LOADING_UPDATE,
        payload: false
      })
    })
  }
}

export function updateMovie(data) {
  return (dispatch) => {
    fetch(`${url}/movies/${data.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.getItem('token')
      },
      body: JSON.stringify({
        title: data.title,
        synopsis: data.synopsis,
        trailerUrl: data.trailerUrl,
        imgUrl: data.imgUrl,
        rating: data.rating,
        genreId: +data.genreId,
        price: +data.price,
        quantity: +data.quantity
      })
    })
    .then((res) => {
      Swal.fire('Updated!', `movie was Updated`, 'success')
      return res.json()
    })
    .then(movie => {
      console.log(movie)
    }).catch((err) => {
      dispatch({
        type: SET_ERROR,
        payload: err
      })
    });
  }
}